import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { FontSizeService } from 'src/app/services/font-size.service';
import {V3ExamSession, V3ExamSessionPart} from "../../model/v3/cspa";

@Component({
    selector: 'app-exam-summary',
    templateUrl: './exam-summary.component.html',
    styleUrls: ['./exam-summary.component.scss'],
    standalone: false
})
export class ExamSummaryComponent implements OnInit, OnDestroy {
  private _session: V3ExamSession
  @Input() sessionParts: V3ExamSessionPart[] = []
  @Input() isSampleExam: boolean
  @Input()
  get session(): V3ExamSession {
    return this._session
  }
  set session(session: V3ExamSession) {
    this._session = session
  }

  constructor(
    public fontSizeService: FontSizeService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(){
    this.fontSizeService.setToDefault()
  }

  getTotalScore(): number {
    return this.sessionParts?.reduce((total, part) => total + part?.score * part?.weight, 0)
  }

  getStageNumber(): number {
    return parseInt(this.session?.chapterName?.charAt(this.session?.chapterName?.length - 1))
  }

  getStageRange(): string {
    return this.getStageNumber() < 3 ? 'STAGE_1_2' : 'STAGE_3_12'
  }
}
